import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js'; 
import { Md5 } from 'ts-md5';
@Injectable({
  providedIn: 'root'
})
export class FunctService {
  domain: string;
  microsoftAddress(microsoftAddress: any, arg1: { headers: import("@angular/common/http").HttpHeaders; }) {
    throw new Error('Method not implemented.');
  }
  PRIVATE_JWK: any={
    kty: 'RSA',
    n: '3rHgkGrx1zdAdv6fMLMABBEER1Mt_BNdAc_DtIG9AGUtGDodeBrNLpzqDZe5goP5n_wwbHaWMq7SYa1NBeoyd38LFIo_xOH_XyyxUApMNxwK6wU25oWHiJYEGhhRCE_51cL1kSNVGwc0MLY4u7RXpA41B8pf4v2hyDQBecdZ9XbN2Htpf4yWIxJzfT2Vm8JFaRADnW6dCZX3BUPNmT-x_NT2iN5SpzxjMuKajFuUspAAwiDX1mhmDDGUM2pG5DGYAKbkzl7XBZwwaTWq4iqPvllPQVhJ1tm0sU8BHaM4QtDZ5E1pQO2bDFrK3hWONnbvj7DPMBU1RkUyUssR76L_FQ',
    e: 'AQAB',
    d: 'uxEY3re3Z14WXN8Owk3bGY9h1LhezH1Hh5oLf7nsFkTnWI6Y6qc47IsLYVeukaBjNK0X0ETdbr3EJCD7rphIxHCH0j0_zBc7-asFV4MO-swnr7y1nXdVnrrFv1Xl2-GysIoQ1lajywyGHtUzWxnm9PyqN10cpwT_vblR9AYt3y7YBMvgVPCwKXA7GQ3XkfB_Ss_4WloIKVG8XGYRJo_bJ0FSk395Z6eOEVmjjd8U8bA3LMiFwP6a7mJxp8TjZytnWFwkNHWIlkcp2zHdWEWHmfuLD2BPH_azev1VRhrIveggiqcjXW1hIxDmf6RGtQifMyPENkUiB86fa1YFWBlFgQ',
    p: '9D-NSPT1blgePpZEx5XE8XRu4ANA0O-KJvGUH7ERfFxlMRVZQ3j-_MMeiHfEJMaTMLUj3qxOq8XXaya9rTB1doHIEevbnR4xUtam09Zmkt03b5_kMGE-OX7l905lEiNJhIB0ja3hOlRN2UTvtngUI2UBrrMRxClZF2btu54Swz0',
    q: '6WjZHy4Csu8X0wUZuZUVaPV4S8mP51rJNwCvCim5bU1rgNRwHF9cC8ElFk4Xo1SOAUNldat3Sfp5VbMB7NizJ1ZXk4KBwHrr3Cqef8yaaoN7d8BaHxNU-A4K1_stVt9CcbSv0L8JCVALj12v-nvHwq55X8uYPsaAOa14tG2CCLk',
    dp: 'kSaPbRL-JBRD7QfaWg3cW23JUmE8jK4-GMSqNWdCL_isvk2knZ9zUX0XURxzuTM1V9XeOj-GBTjuuyPrxteshr-7yUK0YZwGzeb4f53DmXXTswd_UW0I0JxkR-MT14KW9yJroaL63XIqTXtVRcf4l8w4Ar0ySrQT2P93Om9HUTU',
    dq: 'l9DVoH0pzj7LjTq9D8OTaHB5LTpOOloHlJoCQCcBb8GykdobjajM0uxu9gIXR-ogb1vp6056yYh8USycrPQKGyUC03RIduy86rhh3Zg0O-GHdk2LkLjfRHTFwtOiGuYebpzq2mjXNNJ2omp6ov7N4KfhVFi1judH0bwuTZUIxik',
    qi: '2AmkgOGZxieo8ZTqbafP6JbbrA-DDfUk5jxJNAgTgJ43kuSqR3VB6gObUgNk2d5HwIhYdUmjRDA0WyNtRiOpjnsde0Nx0jPLFniMGk_7-5DCqGWrTLRiUDr9ufn2e_8muGiZj-s6-SLiGrnhh33sWOi1zbnUeVxXHTwXBXAJZv0',
    kid: 'prod-sso-key-202607',
    use: 'sig',
    alg: 'RS256'
  };
  public ipaddress: any;
  public appName: any;
  public secretKey: any;
  public chatSignalrConnect: any;
  public chatSignalrApi: any;
  public signalrInfo: any;
  public fileName: any;
  public issuer: any;
  constructor() {  
    //.Net api
    this.appName="Lucky2d"; 
    //.Net api
   // this.ipaddress = "http://localhost:22735/api/"; 
    //lucky2d
    this.ipaddress = "https://api.lucky2d.com/api/";  
    this.issuer = 'https://lucky2d.com';
    this.fileName = "lucky";  
    
    //crazybossy   
    // this.ipaddress = "https://api.crazybossy.com/api/";  
    // this.issuer = 'https://crazybossy.com';   
    // this.fileName = "crazy"; 
    
    
    //testDev        
    // this.ipaddress = "https://demoapi.crazybossy.com/api/";
    // this.issuer = 'https://demo.crazybossy.com';  
    // this.ipaddress = "https://demoapi.lucky2d.com/api/"; 
    // this.issuer = 'https://demo.lucky2d.com';  
    
    //chatsignalr
    this.chatSignalrConnect= ''; //"https://chatapi.lucky2d.com/chat";
    this.chatSignalrApi = ''; //"https://chatapi.lucky2d.com/api/";

    this.signalrInfo = "https://signalr.crazybossy.com/api/info/";//"https://signalr.lucky2d.com/api/info/";
    this.secretKey="Fl1Ab4Vw5Nc7Oq7Tg4En6Tl2Hc5Lj6Im0Lm1Jj3Gh9R";
    this.domain = "https://www.lucky2d.com/";    
  }

    b64UrlDecode(input: string): string {
    const b64 = input.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  }

   randomUuid(): string {
    const cryptoObj = (window as any).crypto;
    if (cryptoObj?.randomUUID) {
      return cryptoObj.randomUUID();
    }
    const bytes = new Uint8Array(16);
    cryptoObj.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  encrypt(plainText: string): string {      
    var key = CryptoJS.enc.Utf8.parse('7061737323313233');
    var iv = CryptoJS.enc.Utf8.parse('7061737323313233');    
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key,
      {
        keySize: 128,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    //console.log(encrypted.toString());
    return encrypted.toString();
   }

   decrypt(text: string){
    var key = CryptoJS.enc.Utf8.parse('7061737323313233');
    var iv = CryptoJS.enc.Utf8.parse('7061737323313233'); 
    var decryptedData = CryptoJS.AES.decrypt(text, key, {
      keySize: 128,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    return decryptedData;   
   }
  

   getSignature(signature: string): string{
    var sin= Md5.hashStr(signature).toString();
    return sin;
   }

   decryptTransfer(text: string){
    var key = CryptoJS.enc.Utf8.parse('JKLASD9876543210');
    var iv = CryptoJS.enc.Utf8.parse('JKLASD9876543210'); 
    var decryptedData = CryptoJS.AES.decrypt(text, key, {
      keySize: 128,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    return decryptedData;   
   }

   encryptTransfer(text: string){
    var key = CryptoJS.enc.Utf8.parse('JKLASD9876543210');
    var iv = CryptoJS.enc.Utf8.parse('JKLASD9876543210');    
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key,
      {
        keySize: 128,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    //console.log(encrypted.toString());
    return encrypted.toString();
   }

}
